function Footer() {
    return (
        <>
            <footer className="has-text-centered is-size-7 mt-auto mb-0 pb-5">
                <div>
                    <div className="is-divider is-left"></div>
                </div>
                <div className="mb-4">
                    <div className="columns mt-3 is-mobile">
                        <div className="column">
                            <span>Copyright @2026</span>
                        </div>
                    </div>
                    <br />
                </div>

            </footer>
        </>
    );
}


export default Footer;


